import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Crown, Quote } from "lucide-react";
import { api } from "../../lib/api";
import { CategoryIcon } from "../CategoryIcon";
import { trackEvent } from "../../lib/analytics";

export const LandingFoundersPick = () => {
  const [pick, setPick] = useState(null);

  useEffect(() => {
    api.get("/public/founders-pick").then((r) => setPick(r.data)).catch(() => setPick(null));
  }, []);

  if (!pick) return null;

  return (
    <div className="mt-10 max-w-5xl border border-amber-300/40 bg-[#0c0a06] relative overflow-hidden" data-testid="founders-pick">
      <div className="absolute -top-px left-0 h-px w-40 bg-gradient-to-r from-amber-300 to-transparent" />
      <div className="grid gap-8 p-6 sm:p-8 lg:grid-cols-12 lg:items-center">
        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-amber-300" data-testid="founders-pick-kicker">
            <Crown size={13} strokeWidth={2.5} /> Founder's Pick of the Week
            <span className="text-zinc-600">·</span>
            <span className="text-zinc-500 normal-case tracking-normal" data-testid="founders-pick-week">{pick.week_label}</span>
          </div>
          <div className="mt-4 flex items-start gap-4">
            <CategoryIcon image={pick.image_icon} lucide={pick.icon} size={56} glow={false} />
            <div className="min-w-0">
              <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">Track {String(pick.order).padStart(2, "0")} · {pick.prompt_count} prompts</div>
              <h3 className="mt-1 font-display text-2xl font-black tracking-tight text-white sm:text-3xl" data-testid="founders-pick-name">{pick.name}</h3>
            </div>
          </div>
          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-zinc-300 sm:text-base" data-testid="founders-pick-why">{pick.why}</p>
          <Link
            to={`/p/${pick.slug}`}
            onClick={() => trackEvent("founders_pick_click", { slug: pick.slug })}
            className="mt-6 inline-flex min-h-12 items-center gap-2 border border-amber-300/60 px-5 text-xs font-black uppercase tracking-[0.18em] text-amber-200 transition-[background-color,color,transform] hover:-translate-y-0.5 hover:bg-amber-300 hover:text-black"
            data-testid="founders-pick-cta"
          >
            Read the track <ArrowRight size={14} />
          </Link>
        </div>
        <blockquote className="border-l-2 border-amber-300/50 pl-5 lg:col-span-5 lg:border-l-0 lg:border-t-0 lg:pl-8" data-testid="founders-pick-quote">
          <Quote size={22} className="text-amber-300/60" />
          <p className="mt-3 font-display text-xl font-bold leading-snug text-amber-100 sm:text-2xl">“{pick.quote}”</p>
          <footer className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">— {pick.picked_by}</footer>
        </blockquote>
      </div>
    </div>
  );
};
